export enum Timezones {
  'Pacific/Honolulu' = 'Hawaii',
  'America/New_York' = 'Eastern',
  'America/Chicago' = 'Central',
  'America/Denver' = 'Mountain',
  'America/Phoenix' = 'Mountain (Arizona)',
  'America/Los_Angeles' = 'Pacific',
  'America/Anchorage' = 'Alaska',
}
